import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ui/icons';
import { Tooltip } from '@web/atoms';
import { Trigger } from './styles';

export const TooltipIcon = ({
  children,
  name = 'more info',
  placement = 'left',
  variant = 'default',
  height = true,
  colorVariant,
  tooltipColor = 'neutral.dark',
}) => {
  const trigger = props => (
    <Trigger role={'tooltip'} {...props}>
      <Icon
        iconName={variant === 'info' ? 'information' : 'help-circle'}
        alt={name}
        color={tooltipColor}
        size="22"
        id="tooltip_icon"
      ></Icon>
    </Trigger>
  );

  return (
    <Tooltip
      placement={placement}
      trigger={trigger}
      colorVariant={colorVariant}
    >
      {children}
    </Tooltip>
  );
};

TooltipIcon.displayName = 'TooltipIcon';

TooltipIcon.propTypes = {
  colorVariant: PropTypes.string,
  children: PropTypes.node.isRequired,
  name: PropTypes.string,
  placement: PropTypes.oneOf([
    'auto',
    'auto-end',
    'auto-start',
    'top',
    'top-end',
    'top-start',
    'right',
    'right-end',
    'right-start',
    'bottom',
    'bottom-end',
    'bottom-start',
    'left',
    'left-end',
    'left-start',
  ]),
  variant: PropTypes.oneOf(['default', 'info']),
  size: PropTypes.string,
  height: PropTypes.bool,
  tooltipColor: PropTypes.string,
};
